import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.css';

export async function initTomSelect(parentElem: HTMLElement | Document): Promise<void> {
  const selects = parentElem.querySelectorAll<HTMLSelectElement>('select.select2');
  selects.forEach((select) => {
    // Check if TomSelect is already initialized on this element
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((select as any).tomselect) {
      return;
    }

    const isMultiple = select.multiple;
    new TomSelect(select, {
      plugins: isMultiple
        ? {
            dropdown_input: {},
            remove_button: { title: 'Odstranit' },
            clear_button: { title: 'Vymazat vse' },
          }
        : ['dropdown_input'],
      allowEmptyOption: true,
      create: false,
      maxOptions: null,
      hidePlaceholder: !isMultiple,
    });
  });
}
